import { httpManager, whenResponseWithError } from './manager'

const apiPublic = httpManager.create({
  baseURL: process.env.BASE_URL,
  headers: {
    'X-Robots-Tag': 'noindex, nofollow'
  }
})

apiPublic.interceptors.response.use((response) => response, whenResponseWithError)

export default apiPublic
